import React from 'react';
import PropTypes from 'prop-types';
import MapInfo from './info';

class MapInfoGroup extends React.Component {

  render() {
    return (
      <div style={{ maxHeight: 400, overflowY: 'scroll' }}>
        {
          this.props.features.map(
            (feature, index) => (
              <div key={index} style={index === 0 ? {} : { borderTop: '1px solid black', marginTop: 15, paddingTop: 15 }}>
                <MapInfo feature={feature} />
              </div>
            )
          )
        }
      </div>
    )
  }


}

MapInfoGroup.propTypes = {
  features: PropTypes.arrayOf(
    MapInfo.propTypes.feature
  ).isRequired
};

export default MapInfoGroup;


// WEBPACK FOOTER //
// ./src/app/map/info-group.js